<template>
  <div class="focused-panel">
    <div class="d-flex polytron-toolbar">
      <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create well water zone" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select well water zone" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit well water zone" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>

      <!--<b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled"
             variant="primary">
        <icon scale=".6" name="pencil-alt"/>
      </b-btn>-->

      <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete well water zone" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn>
    </div>

    <b-modal no-close-on-backdrop no-close-on-esc v-model="showForm" :title="formTitle" @ok="onOK" @cancel="onCancel">
      <div slot="modal-header">
        <label>{{formTitle}}</label>
      </div>
      <div class="p-2">
        <b-form>
          <b-form-group label="Water dest:" >
            <b-form-input id="water_dest"
                          v-model="wellAttrs['water_dest']"
                          placeholder="Enter water_dest otherwise it will be generated"
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Tie-in ident:" >
            <b-form-input id="field_name"
                          v-model="wellAttrs['tie_in_ident']"
                          placeholder="Enter tie_in_ident otherwise it will be generated"
            ></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>

  </div>
</template>

<script>
  import 'vue-awesome/icons/arrows-alt'
  import 'vue-awesome/icons/times'
  import 'vue-awesome/icons/plus'
  import 'vue-awesome/icons/save'
  import 'vue-awesome/icons/check'

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'

  export default {
    name: 'water_polytron',
    components: {

    },
    mixins: [FeatureEditorMixin],
    data () {
      return {
        markLastModified: false,
        featureId: null,
        addPolyEnabled: false,
        addLineEnabled: false,
        addPointEnabled: false,
        options: [],
        causes: [],
        wellLayerName: 'v4:well_allocation_zones_water',
        geometryName: 'geo',
        idName: 'id',
        geomType: 'Polygon',
        identName: 'ident',
        wellAttrs: {
          tie_in_ident: null,
          water_dest: null
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/WellWaterZoneEditor.vue